import React from 'react'

const Manual_ver_estadisticas_campanas_email = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Ver estadísticas de tus campañas de email
        </h2>
        <iframe
          src="https://scribehow.com/embed/Ver_estadisticas_de_tus_campanas_de_email__Fr16og9hRmm5fzOK2oc9bA?as=scrollable"
          className="scribe-iframe-general-81"
          width="100%"
          height="3200"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_ver_estadisticas_campanas_email
